<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="600">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-ASSESSMENT-TYPE' : 'EDIT-ASSESSMENT-TYPE') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'ASSESSMENT-TYPE-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="consentType">{{ 'CONSENT-TYPE' | translate
                    }}</label>
                <kendo-switch formControlName="consentType" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
            <div class="col-6">
                <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="active">{{ 'ENABLED' | translate }}</label>
                <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>